import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { SOMETHING_ELSE_OPTION_ID } from './chatMessageContentTypes';
import { ChatMessageModel } from './ChatMessageModel';
export class ConversationModel {
    static fromDTO(dto) {
        return new ConversationModel(dto.conversationId, dto.draftId, dto.turn, dto.messages.map(ChatMessageModel.fromDTO));
    }
    static ofMessages(messages) {
        return new ConversationModel('', null, null, messages);
    }
    isTurnInFlight() {
        return this.turn != null;
    }
    hasUserMessage() {
        return this.messages.some((message)=>message.isUser());
    }
    activeConfirmation(localDecisions) {
        const last = this.messages[this.messages.length - 1];
        if (last == null || !last.isCollapsibleConfirmation()) return null;
        if (localDecisions[last.id()] != null) return null;
        return last;
    }
    pendingSequencedTarget(isThinking) {
        if (!isThinking) return null;
        const last = this.messages[this.messages.length - 1];
        const lastContent = last === null || last === void 0 ? void 0 : last.userContent();
        if (lastContent == null || lastContent.type !== 'apply' && lastContent.type !== 'skip') return null;
        const target = this.messages.find((message)=>message.id() === lastContent.messageId);
        const targetContent = target === null || target === void 0 ? void 0 : target.assistantContent();
        if (target == null || targetContent == null || targetContent.type !== 'sequenced-confirmation') return null;
        return target;
    }
    resolveNumberedListSelection(text) {
        const tail = this.messages[this.messages.length - 1];
        if (tail == null) return null;
        const content = tail.assistantContent();
        if (content == null || content.type !== 'numbered-list') return null;
        const trimmed = text.trim();
        if (!/^[1-9]\d*$/.test(trimmed)) return null;
        const option = content.options[parseInt(trimmed, 10) - 1];
        return option != null ? {
            messageId: tail.id(),
            option
        } : null;
    }
    latestPersistedFilterUpdate() {
        for(let i = this.messages.length - 1; i >= 0; i -= 1){
            const filterUpdate = this.messages[i].persistedFilterUpdate();
            if (filterUpdate != null) return filterUpdate;
        }
        return null;
    }
    followUpLabelFor(message) {
        var _ref;
        var _targetContent_followUp_suggestions_find;
        const content = message.userContent();
        if (content == null || content.type !== 'apply') return null;
        if (content.selectedItemIds.length !== 1) return null;
        const target = this.messages.find((candidate)=>candidate.id() === content.messageId);
        const targetContent = target === null || target === void 0 ? void 0 : target.assistantContent();
        if (targetContent == null || targetContent.type !== 'applied' && targetContent.type !== 'dismissed') {
            return null;
        }
        if (targetContent.followUp == null) return null;
        return (_ref = (_targetContent_followUp_suggestions_find = targetContent.followUp.suggestions.find((s)=>s.id === content.selectedItemIds[0])) === null || _targetContent_followUp_suggestions_find === void 0 ? void 0 : _targetContent_followUp_suggestions_find.label) !== null && _ref !== void 0 ? _ref : null;
    }
    somethingElseSelectionAt(index) {
        const message = this.messages[index];
        const previous = this.messages[index - 1];
        const content = message === null || message === void 0 ? void 0 : message.userContent();
        if (content == null || content.type !== 'prompt') return false;
        const previousContent = previous === null || previous === void 0 ? void 0 : previous.assistantContent();
        if (previousContent == null || previousContent.type !== 'numbered-list' && previousContent.type !== 'bulk-numbered-list') {
            return false;
        }
        return previousContent.options.some((o)=>o.id === SOMETHING_ELSE_OPTION_ID && o.label === content.text);
    }
    constructor(conversationId, draftId, turn, messages){
        _define_property(this, "conversationId", void 0);
        _define_property(this, "draftId", void 0);
        _define_property(this, "turn", void 0);
        _define_property(this, "messages", void 0);
        this.conversationId = conversationId;
        this.draftId = draftId;
        this.turn = turn;
        this.messages = messages;
    }
}
